import api from '../token';

export const DeleteServico = async (dados) => {
  try {
    const response = await api.post('/deleteServico', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};


